import Nullstack from 'nullstack';
export default function IconVaccineOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-vaccine-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 3l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M19 5l-4.5 4.5"
  }), "   ", Nullstack.element("path", {
    d: "M11.5 6.5l6 6"
  }), "   ", Nullstack.element("path", {
    d: "M16.5 11.5l-.5 .5m-2 2l-4 4h-4v-4l4 -4m2 -2l.5 -.5"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 12.5l1.5 1.5"
  }), "   ", Nullstack.element("path", {
    d: "M3 21l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}